import {
  StandardDialog,
} from '@roc/ui';
import { observer } from 'mobx-react';
import { usePayoffRequestStore } from '../hooks/usePayoffRequestStore';
import { useHistory, useRouteMatch } from 'react-router';
import { useLoanRoutes } from '@roc/feature-loans-routes-config';
import { Box, Typography } from '@material-ui/core';
import PayoffDetailsModalContent from './payoffDetailsModalContent';
import { useBaseStore } from '@roc/feature-app-core';
import { useLoanStore } from '@roc/feature-loans-shared';
import { useEffect } from 'react';
import { useDocumentStore } from '@roc/feature-documents';

export const PayoffDetailsDialog = observer(({ loanId }) => {

  const { payoffRequestStore } = usePayoffRequestStore();
  const { globalStore } = useBaseStore();
  const { push } = useHistory();
  const { loanRoutesConfig } = useLoanRoutes();
  const { loanStore, loanStore: { loanDetails } } = useLoanStore();
  const { documentStore } = useDocumentStore();

  useEffect(() => {
    async function getPayoffById() {
      payoffRequestStore.getPayoffById(loanId, payoffRequestStore.selectedPayoffId);
    }
    if (payoffRequestStore.isPayoffDetailsModalOpen) {
      documentStore.loanTodosStore.setShowOnlyPending(false);
      getPayoffById();
    }

  }, [payoffRequestStore.selectedPayoffId])

  const closePayoffDetails = () => {
    payoffRequestStore.setIsPayoffDetailsModalOpen(false);
    payoffRequestStore.getActivePayoffDataByLoanId(loanId);
    payoffRequestStore.getPayoffsByLoanId(loanId);
    payoffRequestStore.setSelectedPayoffId(null);
    if (globalStore.isBorrowerPortal || globalStore.isServicerPortal) {
      push(loanRoutesConfig.loans(loanId).children.payoffRequest.url);
    } else {
      push(loanRoutesConfig.loans(loanId).children.payoffs.url);
    }
  }
  return (
    <>
      <StandardDialog
        open={payoffRequestStore.isPayoffDetailsModalOpen}
        onClose={closePayoffDetails}
        handleClose={closePayoffDetails}
        maxWidth={'xl'}
        title={(
          <Box>
            <Typography variant="h4">
              {`Payoff ${payoffRequestStore?.selectedPayoff?.payoffNumber}`}
            </Typography>
          </Box>
        )}
        dialogContent={
          <PayoffDetailsModalContent loanId={loanId} />
        }
        removeContentBox
      />
    </>
  );
});